import { useMemo } from 'react';
import useFreeTrialHook from '@/hooks/useFreeTrialHook';
import { useAppContext } from '@/context/AppContext/AppContext';

export function useBrandingToggleVisible(): boolean {
  const { isFreemiumUser, isFreeTrialEnabled } = useFreeTrialHook();
  const {
    adminAppStore: { user: { is_content_lab_standalone } = { is_content_lab_standalone: false } }
  } = useAppContext();

  return useMemo(() => {
    const isNonPaidUser = isFreeTrialEnabled || isFreemiumUser;
    return Boolean(is_content_lab_standalone && isNonPaidUser);
  }, [is_content_lab_standalone, isFreeTrialEnabled, isFreemiumUser]);
}
